import { IdentifierTypePredicate } from "typescript";
import {
  monitorProgramPreviewShape,
  goalTemplatePreviewShape,
} from "../interfaces/classTypes";

export class MonitorProgramPreview {
  public id: number;
  public name: string;
  public goalTemplateList: any;

  constructor(data: monitorProgramPreviewShape) {
    this.id = data.id;
    this.name = data.label;
    this.goalTemplateList = data.activeGoalTemplatePreviews.map(
      (template) => new goalTemplatePreview(template)
    );
  }
}

export class goalTemplatePreview {
  public id: number;
  public name: string;
  public type: string;
  public leaderboard: boolean;
  public frequency: string;
  public occurrence: string;

  constructor(data: goalTemplatePreviewShape) {
    this.id = data.id;
    this.name = data.name;
    this.type = data.type;
    this.leaderboard = data.leaderboard;
    this.frequency = data.frequency;
    this.occurrence = data.occurrence;
  }
}
